// Deep link into the functional diagram page with a connector's pins already
// focused, so the right panel opens straight on the pins detail diagram.
//
//   /functional-diagrams/vin/<vin>?subsystem=<id>&component=<id>&pins=1,2
//
// Both sides of the link live here to keep the parameter names in one place:
// the pinout tables build it (via the related diagrams modal) and the
// functional diagram page consumes it.

export const SUBSYSTEM_PARAM = 'subsystem'
export const COMPONENT_PARAM = 'component'
export const PINS_PARAM = 'pins'

export const diagramSearchParams = ({
  subsystemId,
  componentId,
  pins = [],
}) => {
  const params = new URLSearchParams()
  params.set(SUBSYSTEM_PARAM, subsystemId)

  if (componentId && pins.length > 0) {
    params.set(COMPONENT_PARAM, componentId)
    params.set(PINS_PARAM, pins.join(','))
  }

  return params.toString()
}

// Returns null unless both a component and at least one pin are present.
export const readPinsFocusParams = (searchParams) => {
  const componentId = searchParams.get(COMPONENT_PARAM)
  const pins = searchParams.get(PINS_PARAM)?.split(',').filter(Boolean) || []

  if (!componentId || pins.length === 0) return null

  return { componentId, pins }
}

export const deletePinsFocusParams = (searchParams) => {
  searchParams.delete(COMPONENT_PARAM)
  searchParams.delete(PINS_PARAM)
  return searchParams
}
